import { NAVIGATION_ITEMS, NavigationItem } from '@/composables/navigationItems'

export type DashboardPickerDashboard<T extends string = string> = {
  title: string
  prebuilt: boolean
  icon: string
  dashboardId: T
  tags?: readonly string[]
  navigationItem?: NavigationItem
}

const configs = {
  'simplified-overview': {
    dashboardId: 'simplified-overview',
    title: NAVIGATION_ITEMS.overviewDashboard.title,
    prebuilt: true,
    icon: NAVIGATION_ITEMS.overviewDashboard.icon,
    navigationItem: NAVIGATION_ITEMS.overviewDashboard,
  },
  'barn-management-dashboard': {
    dashboardId: 'barn-management-dashboard',
    title: NAVIGATION_ITEMS.barnManagementDashboard.title,
    prebuilt: true,
    icon: NAVIGATION_ITEMS.barnManagementDashboard.icon,
    navigationItem: NAVIGATION_ITEMS.barnManagementDashboard,
  },
  'measurement-dashboard': {
    dashboardId: 'measurement-dashboard',
    title: NAVIGATION_ITEMS.measurementsDashboard.title,
    prebuilt: true,
    icon: NAVIGATION_ITEMS.measurementsDashboard.icon,
    navigationItem: NAVIGATION_ITEMS.measurementsDashboard,
  },
  'region-dashboard': {
    dashboardId: 'region-dashboard',
    title: NAVIGATION_ITEMS.regionOverviewDashboard.title,
    prebuilt: true,
    icon: NAVIGATION_ITEMS.regionOverviewDashboard.icon,
    navigationItem: NAVIGATION_ITEMS.regionOverviewDashboard,
    tags: ['pigs'],
  },
  'fattening-overview': {
    dashboardId: 'fattening-overview',
    title: NAVIGATION_ITEMS.fatteningOverview.title,
    prebuilt: true,
    icon: NAVIGATION_ITEMS.fatteningOverview.icon,
    navigationItem: NAVIGATION_ITEMS.fatteningOverview,
    tags: ['pigs'],
  },
} as const

export type PrebuiltDashboardId = keyof typeof configs

export const prebuiltDashboards: {
  readonly [K in PrebuiltDashboardId]: DashboardPickerDashboard<K>
} = configs

export function isDefaultDashboard(dashboardIdentifier?: string): dashboardIdentifier is PrebuiltDashboardId {
  return !!dashboardIdentifier && dashboardIdentifier in prebuiltDashboards
}
